/* ============================================================
   VividEye Shopify Theme — JavaScript
   ============================================================ */

(function () {
  'use strict';

  // ===== Mobile Drawer =====
  const hamburger = document.getElementById('HamburgerBtn');
  const drawer = document.getElementById('MobileDrawer');
  const overlay = document.getElementById('DrawerOverlay');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    overlay && overlay.classList.add('is-open');
    hamburger && hamburger.classList.add('is-open');
    hamburger && hamburger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    overlay && overlay.classList.remove('is-open');
    hamburger && hamburger.classList.remove('is-open');
    hamburger && hamburger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }
  window.closeDrawer = closeDrawer;

  hamburger && hamburger.addEventListener('click', () => {
    drawer.classList.contains('is-open') ? closeDrawer() : openDrawer();
  });
  overlay && overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDrawer(); });

  // ===== Cart Drawer =====
  const cartBtn = document.getElementById('CartBtn');
  cartBtn && cartBtn.addEventListener('click', () => {
    window.location.href = '/cart';
  });

  // ===== Header shadow on scroll =====
  const header = document.querySelector('.site-header');
  if (header) {
    let lastY = 0;
    window.addEventListener('scroll', () => {
      const y = window.scrollY;
      if (y > 8) header.classList.add('is-scrolled');
      else header.classList.remove('is-scrolled');
      lastY = y;
    }, { passive: true });
  }

  // ===== Product Gallery (manual switching with thumbs + prev/next + dots) =====
  const slides = document.querySelectorAll('[data-product-slides] .product-gallery__slide');
  const thumbs = document.querySelectorAll('[data-product-thumbs] .product-gallery__thumb');
  const dots = document.querySelectorAll('[data-gallery-dots] .product-gallery__dot');
  const prevBtn = document.querySelector('[data-gallery-prev]');
  const nextBtn = document.querySelector('[data-gallery-next]');

  if (slides.length > 0) {
    let currentIdx = 0;

    function showSlide(idx) {
      if (idx < 0) idx = slides.length - 1;
      if (idx >= slides.length) idx = 0;
      slides.forEach((s, i) => s.classList.toggle('is-active', i === idx));
      thumbs.forEach((t, i) => t.classList.toggle('is-active', i === idx));
      dots.forEach((d, i) => d.classList.toggle('is-active', i === idx));

      // Scroll active thumb into view
      const activeThumb = document.querySelector('[data-product-thumbs] .product-gallery__thumb.is-active');
      if (activeThumb && activeThumb.scrollIntoView) {
        activeThumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      }

      currentIdx = idx;
    }

    thumbs.forEach((t, i) => {
      t.addEventListener('click', () => showSlide(i));
    });
    dots.forEach((d, i) => {
      d.addEventListener('click', () => showSlide(i));
    });
    if (prevBtn) prevBtn.addEventListener('click', () => showSlide(currentIdx - 1));
    if (nextBtn) nextBtn.addEventListener('click', () => showSlide(currentIdx + 1));

    // Touch swipe support
    const mainImg = document.querySelector('[data-product-main-image]');
    if (mainImg) {
      let startX = 0, startY = 0;
      mainImg.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
      }, { passive: true });
      mainImg.addEventListener('touchend', (e) => {
        const dx = e.changedTouches[0].clientX - startX;
        const dy = e.changedTouches[0].clientY - startY;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
          if (dx < 0) showSlide(currentIdx + 1);
          else showSlide(currentIdx - 1);
        }
      }, { passive: true });
    }
  }

  // ===== Variant Picker =====
  const variantOptions = document.querySelectorAll('.variant-option');
  variantOptions.forEach((opt) => {
    opt.addEventListener('click', () => {
      variantOptions.forEach((o) => o.classList.remove('is-selected'));
      opt.classList.add('is-selected');
    });
  });

  // ===== Quantity Inputs =====
  document.querySelectorAll('.qty-input').forEach((qty) => {
    const minus = qty.querySelector('button[data-action="minus"]');
    const plus = qty.querySelector('button[data-action="plus"]');
    const input = qty.querySelector('input');
    if (minus && plus && input) {
      minus.addEventListener('click', () => { input.value = Math.max(1, parseInt(input.value || 1) - 1); input.dispatchEvent(new Event('change')); });
      plus.addEventListener('click', () => { input.value = parseInt(input.value || 1) + 1; input.dispatchEvent(new Event('change')); });
    }
  });

  // ===== AJAX Add to Cart =====
  document.querySelectorAll('form[action="/cart/add"]').forEach((form) => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = form.querySelector('button[type="submit"]');
      const original = btn ? btn.textContent : '';
      if (btn) { btn.textContent = 'Adding...'; btn.disabled = true; }
      try {
        const fd = new FormData(form);
        const res = await fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
          method: 'POST',
          body: fd,
          headers: { 'Accept': 'application/json' }
        });
        if (!res.ok) throw new Error('Add to cart failed');
        const data = await res.json();
        // Update cart count badge
        const cart = await fetch('/cart.js').then(r => r.json());
        const badge = document.querySelector('.cart-count');
        if (badge) { badge.textContent = cart.item_count; }
        else if (cart.item_count > 0) {
          const cartBtn = document.getElementById('CartBtn');
          if (cartBtn && !cartBtn.querySelector('.cart-count')) {
            const span = document.createElement('span');
            span.className = 'cart-count';
            span.textContent = cart.item_count;
            cartBtn.appendChild(span);
          }
        }
        if (btn) btn.textContent = '✓ Added';
        setTimeout(() => { if (btn) { btn.textContent = original; btn.disabled = false; } }, 1500);
      } catch (err) {
        console.error(err);
        if (btn) { btn.textContent = original; btn.disabled = false; }
        alert('Could not add to cart. Please try again.');
      }
    });
  });

  // ===== Smooth anchor scroll =====
  document.querySelectorAll('a[href^="#"]').forEach((a) => {
    a.addEventListener('click', (e) => {
      const target = document.querySelector(a.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  // ===== Hero Carousel =====
  const heroSlides = document.querySelectorAll('.hero-slide');
  const heroDots = document.querySelectorAll('.hero-dot');
  if (heroSlides.length > 1) {
    let currentSlide = 0;
    let heroTimer = null;

    function goToSlide(idx) {
      heroSlides.forEach((s, i) => s.classList.toggle('is-active', i === idx));
      heroDots.forEach((d, i) => d.classList.toggle('is-active', i === idx));
      currentSlide = idx;
    }

    function nextSlide() {
      goToSlide((currentSlide + 1) % heroSlides.length);
    }

    function startAutoPlay() {
      stopAutoPlay();
      heroTimer = setInterval(nextSlide, 5000);
    }

    function stopAutoPlay() {
      if (heroTimer) { clearInterval(heroTimer); heroTimer = null; }
    }

    heroDots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const target = parseInt(dot.dataset.target || '0', 10);
        goToSlide(target);
        startAutoPlay();
      });
    });

    // Pause on hover
    const carousel = document.getElementById('HeroCarousel');
    if (carousel) {
      carousel.addEventListener('mouseenter', stopAutoPlay);
      carousel.addEventListener('mouseleave', startAutoPlay);
    }

    // Start autoplay
    startAutoPlay();
  }

  // ===== Announcement bar close =====
  const annClose = document.querySelector('.announcement-bar__close');
  if (annClose) {
    annClose.addEventListener('click', () => {
      const bar = document.getElementById('AnnouncementBar');
      if (bar) bar.style.display = 'none';
    });
  }

  // ===== Sticky Add-to-Cart Bar (Mobile) =====
  const stickyBar = document.querySelector('[data-sticky-bar]');
  const stickyBtn = document.querySelector('[data-sticky-add]');
  const stickyPriceEl = document.querySelector('[data-sticky-price]');
  const productActions = document.querySelector('.product-info__actions');
  const productForm = document.querySelector('[data-product-form]');

  if (stickyBar && stickyBtn && productActions) {
    document.body.classList.add('has-sticky-bar');

    // Sync price with current variant
    const updateStickyPrice = () => {
      const priceEl = document.querySelector('[data-price-current]');
      if (priceEl && stickyPriceEl) stickyPriceEl.textContent = priceEl.textContent;
    };
    updateStickyPrice();

    // Click sticky button -> scroll to form and trigger add to cart
    stickyBtn.addEventListener('click', () => {
      if (productForm) {
        productForm.scrollIntoView({ behavior: 'smooth', block: 'center' });
        const submitBtn = productForm.querySelector('[data-add-to-cart]');
        if (submitBtn) {
          setTimeout(() => submitBtn.click(), 400);
        }
      }
    });

    // Hide sticky bar when add-to-cart button is visible in viewport
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            stickyBar.classList.remove('is-visible');
          } else {
            stickyBar.classList.add('is-visible');
          }
        });
      }, { threshold: 0.1 });
      observer.observe(productActions);
    }
  }

  // ===== Product Reviews System =====
  const reviewsSection = document.querySelector('[data-product-reviews]');
  if (reviewsSection) {
    const productHandle = reviewsSection.dataset.productHandle || 'default';
    const storageKey = `reviews_${productHandle}`;

    // Get sample reviews from inline script
    const sampleScript = document.querySelector('[data-sample-reviews]');
    const sampleReviews = sampleScript ? JSON.parse(sampleScript.textContent) : [];

    // Get user-submitted reviews from localStorage
    const userReviews = (() => {
      try {
        return JSON.parse(localStorage.getItem(storageKey) || '[]');
      } catch (e) {
        return [];
      }
    })();

    let allReviews = [...userReviews, ...sampleReviews];

    // Render functions
    const reviewsList = reviewsSection.querySelector('[data-reviews-list]');
    const loadMoreBtn = reviewsSection.querySelector('[data-load-more]');
    const loadMoreWrap = reviewsSection.querySelector('[data-load-more-wrap]');
    const filterTabs = reviewsSection.querySelectorAll('.review-tab');
    const sortSelect = reviewsSection.querySelector('[data-review-sort]');
    const reviewsCountEl = reviewsSection.querySelector('[data-reviews-count]');

    let currentFilter = 'all';
    let currentSort = 'newest';
    let visibleCount = 3;

    function escapeHtml(s) {
      return String(s || '').replace(/[&<>"']/g, (c) => ({
        '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
      }[c]));
    }

    function timeAgo(dateStr) {
      const d = new Date(dateStr);
      const now = new Date();
      const days = Math.floor((now - d) / (1000 * 60 * 60 * 24));
      if (days === 0) return 'Today';
      if (days === 1) return 'Yesterday';
      if (days < 30) return days + ' days ago';
      if (days < 365) return Math.floor(days / 30) + ' months ago';
      return Math.floor(days / 365) + ' years ago';
    }

    function renderStars(rating) {
      const full = Math.floor(rating);
      const dec = rating - full;
      let html = '<div class="star-rating" data-rating="' + rating + '">';
      for (let i = 1; i <= 5; i++) {
        if (i <= full) {
          html += '<svg width="16" height="16" viewBox="0 0 24 24" fill="#FFB400"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>';
        } else if (i === full + 1 && dec >= 0.5) {
          html += '<svg width="16" height="16" viewBox="0 0 24 24"><defs><linearGradient id="hs-' + i + '"><stop offset="50%" stop-color="#FFB400"/><stop offset="50%" stop-color="#E0E0E0"/></linearGradient></defs><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" fill="url(#hs-' + i + ')"/></svg>';
        } else {
          html += '<svg width="16" height="16" viewBox="0 0 24 24" fill="#E0E0E0"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>';
        }
      }
      html += '</div>';
      return html;
    }

    function getFiltered() {
      let list = [...allReviews];
      if (currentFilter === 'photo') {
        list = list.filter(r => r.photos && r.photos.length > 0);
      } else if (currentFilter !== 'all') {
        const stars = parseInt(currentFilter, 10);
        list = list.filter(r => r.rating === stars);
      }

      switch (currentSort) {
        case 'highest': list.sort((a, b) => b.rating - a.rating); break;
        case 'lowest': list.sort((a, b) => a.rating - b.rating); break;
        case 'helpful': list.sort((a, b) => (b.helpful || 0) - (a.helpful || 0)); break;
        default: list.sort((a, b) => new Date(b.date) - new Date(a.date));
      }
      return list;
    }

    function renderList() {
      if (!reviewsList) return;
      const filtered = getFiltered();
      const toShow = filtered.slice(0, visibleCount);

      if (filtered.length === 0) {
        reviewsList.innerHTML = '<p style="text-align:center;padding:40px 20px;color:#999;">No reviews yet. Be the first to share your thoughts!</p>';
        if (loadMoreWrap) loadMoreWrap.style.display = 'none';
        if (reviewsCountEl) reviewsCountEl.textContent = '0';
        return;
      }

      reviewsList.innerHTML = toShow.map(r => {
        const initials = (r.name || 'A').split(' ').map(s => s[0]).join('').slice(0, 2).toUpperCase();
        const photosHtml = (r.photos && r.photos.length)
          ? '<div class="review-card__photos">' + r.photos.map(p => '<img class="review-card__photo" src="' + escapeHtml(p) + '" alt="Review photo" loading="lazy">').join('') + '</div>'
          : '';
        const verifiedHtml = r.verified ? '<span class="review-card__verified">Verified Purchase</span>' : '';
        return `
          <article class="review-card">
            <div class="review-card__header">
              <div class="review-card__author">
                <div class="review-card__avatar">${escapeHtml(initials)}</div>
                <div class="review-card__meta">
                  <div><span class="review-card__name">${escapeHtml(r.name)}</span>${verifiedHtml}</div>
                  <span class="review-card__date">${escapeHtml(timeAgo(r.date))}</span>
                </div>
              </div>
              <div class="review-card__rating">${renderStars(r.rating)}</div>
            </div>
            <h4 class="review-card__title">${escapeHtml(r.title)}</h4>
            <p class="review-card__body">${escapeHtml(r.body)}</p>
            ${photosHtml}
            <div class="review-card__footer">
              <button type="button" class="review-card__helpful-btn" data-helpful="${escapeHtml(r.id)}">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3"/></svg>
                <span>Helpful</span>
              </button>
              <span class="review-card__count">${r.helpful || 0} found this helpful</span>
            </div>
          </article>
        `;
      }).join('');

      if (loadMoreWrap) loadMoreWrap.style.display = filtered.length > visibleCount ? 'block' : 'none';
      if (reviewsCountEl) reviewsCountEl.textContent = filtered.length;
    }

    // Helpful button
    reviewsList && reviewsList.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-helpful]');
      if (!btn) return;
      const id = btn.dataset.helpful;
      const review = allReviews.find(r => r.id === id);
      if (review) {
        review.helpful = (review.helpful || 0) + 1;
        btn.closest('.review-card__footer').querySelector('.review-card__count').textContent = review.helpful + ' found this helpful';
        btn.style.color = '#0066CC';
        btn.style.borderColor = '#0066CC';
      }
    });

    // Filter tabs
    filterTabs.forEach(tab => {
      tab.addEventListener('click', () => {
        filterTabs.forEach(t => t.classList.remove('is-active'));
        tab.classList.add('is-active');
        currentFilter = tab.dataset.filter;
        visibleCount = 3;
        renderList();
      });
    });

    // Sort
    if (sortSelect) {
      sortSelect.addEventListener('change', (e) => {
        currentSort = e.target.value;
        renderList();
      });
    }

    // Load more
    if (loadMoreBtn) {
      loadMoreBtn.addEventListener('click', () => {
        visibleCount += 3;
        renderList();
      });
    }

    // Write review modal
    const modal = reviewsSection.querySelector('[data-review-modal]');
    const writeBtn = reviewsSection.querySelector('[data-write-review]');
    const closeBtns = reviewsSection.querySelectorAll('[data-modal-close]');
    const overlayEl = reviewsSection.querySelector('[data-modal-overlay]');
    const reviewForm = reviewsSection.querySelector('[data-review-form]');
    const formStars = reviewsSection.querySelectorAll('[data-form-stars] .review-form__star');
    const formRatingInput = reviewsSection.querySelector('[data-form-rating]');

    function openModal() {
      if (modal) {
        modal.classList.add('is-open');
        modal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      }
    }
    function closeModal() {
      if (modal) {
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        if (reviewForm) reviewForm.reset();
        formStars.forEach(s => s.classList.remove('is-active'));
        if (formRatingInput) formRatingInput.value = '';
      }
    }

    writeBtn && writeBtn.addEventListener('click', openModal);
    closeBtns.forEach(btn => btn.addEventListener('click', closeModal));
    overlayEl && overlayEl.addEventListener('click', closeModal);

    // Star rating in form
    formStars.forEach(star => {
      star.addEventListener('click', () => {
        const val = parseInt(star.dataset.star, 10);
        if (formRatingInput) formRatingInput.value = val;
        formStars.forEach((s, i) => {
          s.classList.toggle('is-active', i < val);
        });
      });
      star.addEventListener('mouseenter', () => {
        const val = parseInt(star.dataset.star, 10);
        formStars.forEach((s, i) => {
          s.classList.toggle('is-active', i < val);
        });
      });
    });
    const starsContainer = reviewsSection.querySelector('[data-form-stars]');
    if (starsContainer) {
      starsContainer.addEventListener('mouseleave', () => {
        const val = parseInt(formRatingInput?.value || '0', 10);
        formStars.forEach((s, i) => {
          s.classList.toggle('is-active', i < val);
        });
      });
    }

    // Submit review
    if (reviewForm) {
      reviewForm.addEventListener('submit', (e) => {
        e.preventDefault();
        const fd = new FormData(reviewForm);
        const rating = parseInt(fd.get('rating') || '0', 10);
        if (!rating) { alert('Please select a rating'); return; }
        const newReview = {
          id: 'user-' + Date.now(),
          name: fd.get('name') || 'Anonymous',
          rating: rating,
          title: fd.get('title') || '',
          body: fd.get('body') || '',
          date: new Date().toISOString().split('T')[0],
          verified: false,
          helpful: 0,
          photos: []
        };
        const stored = JSON.parse(localStorage.getItem(storageKey) || '[]');
        stored.unshift(newReview);
        localStorage.setItem(storageKey, JSON.stringify(stored));
        allReviews.unshift(newReview);
        closeModal();
        renderList();
        alert('Thanks for your review!');
      });
    }

    // Initial render
    renderList();
  }
})();